var render, staticRenderFns
import script from "./TestsPerMonth.vue?vue&type=script&lang=js&"
export * from "./TestsPerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58327d3e')) {
      api.createRecord('58327d3e', component.options)
    } else {
      api.reload('58327d3e', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/trending-charts/TestsPerMonth.vue"
export default component.exports